/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ResultCodeEnum {
    APPROVED = 'Approved',
    DECLINED = 'Declined',
    ERROR = 'Error',
    NONE = 'None',
    PENDING = 'Pending',
}